import React, { useState, useEffect } from 'react';
import { isEmpty } from 'lodash';
import Breadcrumb from './Breadcrumb';
import Title from './Title';
import { 
    headerPadding
} from '../Shared/Styles';

export default function Header(props) {

    const [lifeInsuredName, setLifeInsuredName] = useState("");
    const init = () => {
       
        if (props.policyLives && !isEmpty(props.policyLives)) {

            var policyLife = null;

            if (props.distributorClientNo) {
                policyLife = props.policyLives.find(e => e.distributorClientId.toString() === props.distributorClientNo);
            }

            // Fallback for first load when distributorClientNo is resolved after policyLives.
            if (!policyLife) {
                policyLife = props.policyLives[0];
            }

            if (policyLife)
                setLifeInsuredName(policyLife.fullName);
        }
    };

    useEffect(() => {
        try {
            init();
        } catch (error) {
            console.log('error', error);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.policyLives, props.distributorClientNo]);

if (!props.policies) {

    return "loading...";
} else {

    const endPath = window.location.pathname.split('/');
    let endCrumb = endPath[endPath.length - 1]

    return (
        <div className="Header" style={headerPadding}>
            {props.policies.map((policy) =>
                <div key={policy.policyNumber}>
                    <Breadcrumb
                        lifeFullName={ lifeInsuredName }
                        clientId={ props.clientId }
                        appRefNo={ props.appRefNo }
                        distributorNo={ props.distributorNo }
                        distributorClientNo={ props.distributorClientNo }
                        productName={ policy.productName }
                        policyNumber={ policy.policyNumber }
                        endCrumb={ endCrumb }
                    />

                    <Title
                        productName={ policy.productName }
                        policyNumber={ policy.policyNumber }
                        endCrumb={ endCrumb }
                    />
                </div>
            )}
        </div>
    );
}}